// extracted by mini-css-extract-plugin
module.exports = {"defaultColor":"#8A7651","navTextColor":"#fff","textColor":"#141414","lightBlack":"#888","boxShow":"0px 0px 0.1rem #8A7651","pb50":".25rem"};